export const paymentPlanDueHours = {
  HOURS_24: 24,
  HOURS_36: 36,
  HOURS_48: 48,
  HOURS_60: 60,
  HOURS_72: 72,
  HOURS_96: 96,
};

export const DEFAULT_COMPLETE_DUE_HOURS = paymentPlanDueHours.HOURS_48;

export const DEFAULT_ENUM_DUE_HOURS = 'HOURS_72';
